import React from 'react';
import ReactLink from '@client/components/reactLink/ReactLink';

function LinkWrapper({ children, link }) {
  return link ? <ReactLink to={link}>{children}</ReactLink> : children;
}

export default LinkWrapper;
